
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { extract } from '@app/core';
import { LoginLayoutComponent } from '@app/landing/login-layout/login-layout.component';
import { PassforgotComponent } from '@app/landing/passforgot/passforgot.component';
import { LandingComponent } from '@app/landing/landing.component';

import { routesConstants } from '@app/shared/models/LinksView';

const routes: Routes = [
  {
    path: routesConstants.landing,
    component: LandingComponent,
    data: { title: extract('Landing') },
    children: [
      { path: routesConstants.passforgot + '/:userToken', component: PassforgotComponent },
      { path: '**', component: LoginLayoutComponent }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class LandingRoutingModule { }
